import SurveysApp from "./SurveysApp";

export default SurveysApp;
